// Generated from SVG to Code Figma Plugin

export const BaseLineLock = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 1.25C14.6233 1.25006 16.75 3.37669 16.75 6V7.75H17C19.3472 7.75 21.25 9.65279 21.25 12V18.501C21.25 20.8482 19.3472 22.751 17 22.751H7C4.65279 22.751 2.75 20.8482 2.75 18.501V12C2.75 9.65279 4.65279 7.75 7 7.75H7.25V6C7.25 3.37665 9.37665 1.25 12 1.25ZM7 9.25C5.48122 9.25 4.25 10.4812 4.25 12V18.501C4.25 20.0198 5.48122 21.251 7 21.251H17C18.5188 21.251 19.75 20.0198 19.75 18.501V12C19.75 10.4812 18.5188 9.25 17 9.25H7ZM12 2.75C10.2051 2.75 8.75 4.20507 8.75 6V7.75H15.25V6C15.25 4.20511 13.7949 2.75006 12 2.75Z"
      fill="currentColor"
    />
    <rect height="5" width="2" fill="currentColor" rx="1" x="11" y="12.5" />
  </svg>
);
